import { Redirect, Route, Switch, useRouteMatch } from 'react-router';
import Automation from '.';
import { EngineRoutes } from '../../features/engines/EngineRoutes';
import { DedicatedEngineDetail } from '../../features/legacy-engines/containers/DedicatedEngineDetail';
import {
  automationEnginesPath,
  AutomationParams,
  automationPath,
  dedicatedEnginesDetailRoute,
} from './helpers';

export const AutomationRoutes = () => {
  const dedicatedEngineMatch = useRouteMatch<AutomationParams>(
    dedicatedEnginesDetailRoute
  );

  return (
    <Switch>
      <Route exact path={automationPath()} component={Automation} />

      {dedicatedEngineMatch && Number(dedicatedEngineMatch.params.id) && (
        <Route
          exact
          path={dedicatedEnginesDetailRoute}
          component={DedicatedEngineDetail}
        />
      )}

      {/* Engine routes are managed by the feature itself. */}
      <Route path={automationEnginesPath()} render={() => <EngineRoutes />} />

      <Redirect to={automationPath()} />
    </Switch>
  );
};
